import { useQuery } from "react-query";
import { getCompletedInvoiceCount } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetCompletedInvoiceCount = () => {
  return useQuery("GetCompletedInvoiceCount", getCompletedInvoiceCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetCompletedInvoiceCount;
